import { NgModule } from '@angular/core';

// ----- Common -----
import { CommonModule } from '@angular/common';

// ----- Forms -----
import { FormsModule } from '@angular/forms';

// ----- Kendo-Grid Module -----
import { ExcelModule, GridModule } from '@progress/kendo-angular-grid';


import { DepartmentSetupComponent } from './department-setup.component';

@NgModule({
  imports: [
    CommonModule, FormsModule, GridModule, ExcelModule
  ],
  declarations: [
    DepartmentSetupComponent
  ],
  exports: [
    DepartmentSetupComponent
  ],
  providers: [
    
  ]
})
export class DepartmentSetupModule { }
